<template>
    <div class="wrapper">
        <side-bar :sidebar-links="$sidebar.sidebarLinks" type="sidebar"> </side-bar>

        <div class="main-panel">
            <top-navbar></top-navbar>
            <dashboard-content @click.native="toggleSidebar"></dashboard-content>
        </div>
    </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue'
import DashboardContent from './Content.vue'

export default {
    components: {
        TopNavbar,
        DashboardContent
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        }
    }
}
</script>
